import React from 'react';
import BookingList from './BookingList';

/*
 * Scheduled — booking untuk slot waktu di masa depan.
 *
 * `Booking.bookingType = 2` adalah penanda jadwal. Status booking tetap status
 * pekerjaan sebenarnya; slot dan status jadwal hidup di `ScheduleBooking`.
 */
const Scheduled = () => (
  <BookingList
    current="scheduled"
    breadcrumb={['Operations', 'Scheduled']}
    title="Scheduled jobs"
    lead="Bookings placed for a future time slot."
    slug="scheduled"
    bookingType={2}
    legacyHref="/siteadmin/schedule-jobs"
    showSchedule
    emptyTitle="Nothing scheduled"
    emptyMsg="Bookings placed for a future time slot will appear here."
  />
);

export default Scheduled;
